<div id="brand-safety">
    <targeting-container label="BRAND SAFETY" (onEdit)="openSidebar()" [hideRemove]="true"
        [disabled]="isBrandSafetyDisabled">
        <span class="font-weight-bold mr-2" *ngIf="brandSafetyType === brandSafetyTargetingType.concepts.key">
            <span class="font-weight-normal hide-chip-close-button">
                <span *ngIf="includeListCount !== 0">
                    <label class="font-weight-bold">Concepts:&nbsp;</label>
                </span>
                <span *ngIf="includeListCount !== 0">
                    <acl-ngx-tooltip [trigger]="trigger" [disabled]="!tooltipTextForInclude.length"
                        [text]="tooltipTextForInclude.join(', ')">
                    </acl-ngx-tooltip>
                    <ng-template #trigger>
                        <acl-ngx-chip (click)="openSidebar()"
                            [text]="tooltipTextForInclude.length === 1 ? includeListCount :'(' + includeListCount + ')'">
                        </acl-ngx-chip>
                    </ng-template>
                </span>
            </span>
            <span *ngIf="includeListCount === 0" class="font-italic py-1 font-weight-normal">
                <span (click)="openSidebar()" [ngClass]="isDisabled ? 'disabled' : 'cursor-pointer'">Select</span>
            </span>
        </span>
        <span class="font-weight-bold mr-2" *ngIf="brandSafetyType === brandSafetyTargetingType.conceptSet.key">
            <span class="font-weight-normal hide-chip-close-button" *ngIf="conceptSetLabel !== ''">
                <label class="font-weight-bold">Concept Set:&nbsp;</label>
                <acl-ngx-chip (click)="openSidebar()" [text]="conceptSetLabel">
                </acl-ngx-chip>
            </span>
            <span *ngIf="conceptSetLabel == ''" class="font-italic py-1 font-weight-normal">
                <span (click)="openSidebar()"
                    [ngClass]="isBrandSafetyDisabled ? 'disabled' : 'cursor-pointer'">Select</span>
            </span>
        </span>
    </targeting-container>

    <acl-ngx-flyout [open]="open" (close)="cancel()" large="true" portalRoot="brand-safety">
        <acl-ngx-flyout-header title="BRAND SAFETY" (close)="cancel()">
        </acl-ngx-flyout-header>
        <acl-ngx-flyout-body>
            <div>
                <div class="brand-safety-selector">
                    <strong>TARGET BY:</strong>
                    <div class="d-inline-block margin-left-15 margin-bottom-25">
                        <acl-ngx-select menuWidth="160px" [irreversible]="true"
                            [initialValue]="{'value': brandSafetyType}" (change)="handleOnSelectChange($event)">
                            <acl-ngx-option *ngFor="let view of brandSafetyTargetingType | keyvalue"
                                [label]="view.value.label" [value]="view.value.key">
                            </acl-ngx-option>
                        </acl-ngx-select>
                    </div>
                </div>
                <ng-container *ngIf="brandSafetyType === brandSafetyTargetingType.conceptSet.key">
                    <multi-select-auto-complete [placeholder]="'Select Brand Safety Concept Set'"
                        [settings]="conceptSetSettings" [(selectedData)]="selectedConceptSet"
                        (onSelect)="onConceptSetSelect($event)" [disabled]="isDisabled">
                    </multi-select-auto-complete>
                </ng-container>
                <ng-container *ngIf="brandSafetyType === brandSafetyTargetingType.concepts.key">
                    <browse-include-exclude [(dataConfig)]="brandSafetyDataConfig" [settings]="brandSafetySettings"
                        [hidden]="!open">
                    </browse-include-exclude>
                </ng-container>
            </div>
        </acl-ngx-flyout-body>
        <acl-ngx-flyout-footer [leftButton]="saveButton" [rightButton]="cancelButton">
        </acl-ngx-flyout-footer>
    </acl-ngx-flyout>
</div>
